import { useContext, useMemo } from 'react';
import useAffordableRelationshipsQuery from 'hooks/queries/useAffordableRelationshipsQuery';
import { AppContext } from 'contexts/AppContext';

const useAffordableRelationshipsMap = (translated = false) => {
  const { language } = useContext(AppContext);
  const { data: affordableRelationships } = useAffordableRelationshipsQuery();

  return useMemo(() => {
    return Array.isArray(affordableRelationships)
      ? affordableRelationships.reduce((acc, { id, name, translations }) => {
          acc[id] = translated ? translations[language] : name;
          return acc;
        }, {})
      : {};
  }, [affordableRelationships, language, translated]);
};

export default useAffordableRelationshipsMap;
